import { Avatar } from "./Avatar";

// Дева — ИИ-рекрутёр HRDeva. Всё, что делает или предлагает машина, а не
// человек, подписано ею и с её аватаркой: автоматические сообщения в чатах,
// смена этапа ею самой и её предложения, напоминания из переписки, ЛПР,
// найденный в переписке, сводки и наблюдения по кандидату, сводка аналитики.
// Одна подпись и одна картинка на всё приложение — здесь.

export const DEVA_NAME = "Дева";
/** Аватарка Девы: розовый силуэт с облачком на тёмном (public/deva.png). */
export const DEVA_AVATAR_URL = "/deva.png";

export function DevaAvatar({ size = 28 }: { size?: number }) {
  return <Avatar name={DEVA_NAME} src={DEVA_AVATAR_URL} size={size} />;
}
